module.exports = __webpack_public_path__ + "static/media/card-blog5.65e0d233.jpg";